import React, { Component } from "react";
import HorizontalLayout from "../../layout/HorizontalLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class HorizontalLayoutDemo extends Component {
  render() {
    return (
      <HorizontalLayout hgap={20}>
        <CenterLayout className="bg1" width={100} height={50}>
          Left 1
        </CenterLayout>
        <CenterLayout className="bg2" width={100} height={50}>
          Left 2
        </CenterLayout>
        <CenterLayout className="bg3" width={100} height={50}>
          Left 3
        </CenterLayout>
        <CenterLayout className="bg4" width={100} height={50}>
          Left 4
        </CenterLayout>
        <CenterLayout className="bg5" width={100} height={50}>
          Left 5
        </CenterLayout>
      </HorizontalLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.horizontalLayout.js